"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDownloadData = void 0;
var react_1 = __importDefault(require("react"));
var AcButton_1 = require("../button/AcButton");
var AcDownloadData = function (props) {
    var totalElements = props.totalElements, onDownloadClick = props.onDownloadClick, onUploadClick = props.onUploadClick;
    // if (!totalElements) return <></>;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "d-flex justify-content-end ml-auto" },
            react_1.default.createElement("div", { className: "pr-1" },
                react_1.default.createElement(AcButton_1.AcButton, { variant: "outline-apzlinkblue", size: "sm", onClick: onDownloadClick }, "CSV\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(AcButton_1.AcButton, { variant: "outline-apzlinkblue", size: "sm", onClick: onUploadClick }, "CSV\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9")))));
};
exports.AcDownloadData = AcDownloadData;
exports.AcDownloadData.displayName = 'AcDownloadData';
//# sourceMappingURL=AcDownloadData.js.map